<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="alert alert-info">
                        Please note that revenues became payable once we receive the funds from the clients; for producers that are based outside the eurozone, we prefer to keep the number of sales reports to a minimum in order to limit the deductible expense.<br/>
                        For a transfer outside the eurozone, bank charges are of at least 50 USD, so sales reports won’t be made available if the revenues generated are less than 100 USD.
                        <br>
                        <br>
                        You will be notified by email when the sales report is available on your account. You'll then be able to upload your invoice and certificate of residence of residence for tax purposes so the amount due can be transferred to you.
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">{{ $t('revenues_monitoring') }}</h3>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>{{ $t('film') }}</th>
                                    <th>{{ $t('client') }}</th>
                                    <th>{{ $t('rights') }}</th>
                                    <th>{{ $t('territories') }}</th>
                                    <th>{{ $t('from') }}</th>
                                    <th>{{ $t('to') }}</th>
                                    <th>{{ $t('amount') }}</th>
                                    <th>{{ $t('currency') }}</th>
                                    <th>{{ $t('payed_by_client') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="report in reports" :key="report.id">
                                    <td>{{ report.movie }}</td>
                                    <td>{{ report.client }}</td>
                                    <td>{{ report.rights }}</td>
                                    <td>{{ report.territories }}</td>
                                    <td>{{ report.from }}</td>
                                    <td>{{ report.to }}</td>
                                    <td>{{ report.amount }}</td>
                                    <td>{{ report.currency }}</td>
                                    <td>{{ report.paid }}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import movies from "../services/api/movies";

export default {
    name: "RevenuesMonitoring",
    data() {
        return {
            reports: {},
        }
    },
    methods: {
        loadReports() {
            movies.getMonitoringRevenues().then(({data}) => (this.reports = data.data));
        },
    },
    created() {
        this.$Progress.start();
        this.loadReports();
        this.$Progress.finish();
    },
}
</script>

<style scoped>

</style>
